import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { EaChartAbstractComponent } from '../ea-chart-abstract/ea-chart-abstract.component';

@Component({
    selector: 'ea-line-chart',
    templateUrl: './ea-line.component.html',
    styleUrls: ['./ea-line.component.scss'],
    standalone: false
})
export class EaLineComponent
  extends EaChartAbstractComponent<any>
  implements OnInit
{
  constructor(
    protected translate: TranslateService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translate, changeDetectorRef);
  }

  ngOnInit() {
    this.options = {
      ..._.merge(this._options, {
        chart: {
          type: 'spline',
          backgroundColor: 'transparent',
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          gridLineWidth: 1,
          tickWidth: 0,
          label: {
            format: '{value}',
          },
        },
        yAxis: {
          gridLineWidth: 1,
          lineWidth: 1,
          title: {
            text: '',
          },
          labels: {
            format: '{value} €',
          },
          allowDecimals: false,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          valueSuffix: this.valueSuffix,
          valueDecimals: 2,
        },
        plotOptions: {
          spline: {
            marker: {
              symbol: 'circle',
            },

            allowPointSelect: false,
            center: ['50%', '50%'],
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
            },
            enableMouseTracking: true,
          },
        },
      }),
      series: this.series || this._options.series,
    };
  }
}
